module.exports = __webpack_public_path__ + "static/media/9.48ec0614.jpg";